import { CONSTANTS, COUNTRY_CODE, DATE_FORMAT, FILE_EXTENSION_GROUP, FILE_TYPE, LOCALISATION_TEXT } from "../../constants/Constant";
import moment from "moment";
import { ZIPCODE_REGEX } from "../../constants/RegexConstants";
import Utility from "../../utility/Utility";
import TenantManager from "../TenantManager";
import { TENANT, TenantService } from "../TenantManagerService";
import JSZip from "jszip";
import { saveAs } from 'file-saver';
import { Countries, COUNTRY, IN_STATES, US_STATES } from "../../constants/CountryConstant";
import ApiConstants from "../../constants/ApiConstants";
import {showAlert, DKIcons} from 'deskera-ui-library';
import { isShiftOvertimePlanApplicable } from "../../components/compliance/us/ConstantsUS";
import ic_info_warning from "../../assets/icons/ic_info_warning.svg";
import dompurify from 'dompurify';
import RouteManager, { PAGE_ROUTES } from "../RouteManager";
import i18next from "i18next";
import PermissionUtils, { ACTION, MODULE } from "../../components/user-permissions/PermissionUtils";

export function getUserProfilePic(options: any) {
    
    var canvas = document.createElement("canvas");
    var textWidth;
    canvas.style.display = "none";
    canvas.width = options.width ? options.width : 42;
    canvas.height = options.height ? options.height : 42;
    document.body.appendChild(canvas);
    var context = canvas.getContext("2d");
    context.fillStyle = options.backgroundColor ? options.backgroundColor : "#f7f7f7";
    context.fillRect(0, 0, canvas.width, canvas.height);
    context.font = options.font ? options.font : "bold 14px sans-serif";
    context.fillStyle = options.textColor ? options.textColor : "#636363";
    context.textBaseline = options.textBaseline ? options.textBaseline : "middle";
    context.textAlign = options.textAlign ? options.textAlign : "center";
    var first, last;
    var name = options.name.trim().split(" ");
    if (name) {
        first = name[0] && name[0] != "" ? name[0] : null;
        last = name[1] && name[1] != "" ? name[1] : null;
        if (last) {
            var initials = first.slice(0, 1) + last.slice(0, 1);
            textWidth = context.measureText(initials).width;
            context.fillText(
                initials.toUpperCase(),
                canvas.width / 2,
                canvas.height / 2
            );
            var data = canvas.toDataURL();
            document.body.removeChild(canvas);
            return data;
        } else {
            if (first) {
                var initials = first.slice(0, 2);
                textWidth = context.measureText(initials).width;
                context.fillText(
                    initials.toUpperCase(),
                    canvas.width / 2,
                    canvas.height / 2
                );
                var data = canvas.toDataURL();
                document.body.removeChild(canvas);
                return data;
            } else {
                return "../../assets/images/Default-Profile-pic.svg";
            }

        }

    } else {
        return "../.../assets/images/Default-Profile-pic.svg";
    }
}

export function getIncompleteFieldName(field) {
    let fieldName;
    switch (field) {
        case 'address':
            fieldName = 'Address'
            break;
        case 'compensation':
            fieldName = 'Compensation'
            break;
        case 'compensationPeriod':
            fieldName = 'Compensation Period'
            break;
        case 'ctc':
            fieldName = 'CTC'
            break;
        case 'dateOfBirth':
            fieldName = 'Date of Birth'
            break;
        case 'dateOfJoining':
            fieldName = 'Date of Joining'
            break;
        case 'designation':
            fieldName = 'Job Title'
            break;
        case 'emaildId':
            fieldName = 'Email Id'
            break;
        case 'firstName':
            fieldName = 'First Name'
            break;
        case 'lastName':
            fieldName = 'Last Name'
            break;
        case 'paymentDetails':
            fieldName = 'Payment Details'
            break;
        case 'phone':
            fieldName = 'Phone'
            break;
        case 'contact':
            fieldName = 'Contact';
            break;
        case 'reportingManagerName':
            fieldName = 'Direct Manager Name';
            break;
        default:
            fieldName = field;
            break;
    }

    return fieldName;
}

export function getQueryParam(location, param) {
    if (location?.search && param) {
      const query = new URLSearchParams(location.search);
      return query.get(param);
    }
    return null;
  }

  export function trimValue(value) {
    if (value && typeof value === 'string') {
        return value.trim();
    } else {
        return value;
    }
}

export function convertDateToJson(date: any) {
    let jsonDate;
    if (date) {
        if (typeof date === 'string' && !isNaN(Date.parse(date))) {
            const dateObj = new Date(date);
            jsonDate = new Date(dateObj?.getTime() - (dateObj?.getTimezoneOffset() * 60000)).toJSON();
        } else if (typeof date === 'object') {
            jsonDate = new Date(date.getTime() - (date.getTimezoneOffset() * 60000)).toJSON();
        }
    }

    return jsonDate;
}

export function reverseTimezoneOffset(date) {
    if (typeof date === 'object') {
        return new Date(date?.getTime() + date?.getTimezoneOffset() * 60000);
    } else if (typeof date === 'string' && !isNaN(Date.parse(date))) {
        const d = new Date(date);
        return new Date(d.getTime() + d.getTimezoneOffset() * 60000);
    } else {
        return date;
    }
}

export function isInCompliance(countryCode) {
    return countryCode === "IN";
}

export function getCompensationStringType(compensationType) {
        switch (compensationType) {
            case '365':
                return 'year';
            case '30':
                return 'month';
            case 'weekly':
                return 'week';
            case 'hourly':
              return 'hour';
            default:
                return 'year';
        }
    }

    export function getVariableComponentEstimationAmount(component, compensationPeriod, compensation, workWeek, allComponentData, defaultValues, defaultFixed, employeeDetails) {
        let amount = 0;
        const monthlyCompensation:any = getCompensationInPerMonth(compensationPeriod, compensation, workWeek, employeeDetails);
        if (component.isVariable && component.componentConfig.configureAmountBasis) {
            switch (component.componentConfig.configureAmountBasis) {
                case 'percentageOfBasicSalary':
                    amount = monthlyCompensation * component.componentConfig.componentPercent / 100;
                    if(isInCompliance(COUNTRY_CODE.INDIA)) {
                       let index = allComponentData.findIndex(component => (component.name == CONSTANTS.BASIC && component.defaultComponent));
                       if(index != -1) {
                           let selectedComponent = allComponentData[index];
                           let componentValue = defaultValues[selectedComponent.id];
                            amount = (componentValue && componentValue.amount ? componentValue.amount : 0) * component.componentConfig.componentPercent/ 100;
                       }
                    }
                    break;
                case 'percentageOfSpecificComponent':
                    const dependentComponent = getDependentComponent(component.componentConfig.basisComponentId, allComponentData);
                    if (dependentComponent) {
                        let dependentValue = defaultValues[dependentComponent.id];
                        let dependentFixedValue = defaultFixed[dependentComponent.id]
                        if(dependentValue) {
                            amount = dependentValue ? (dependentValue.amount * component.componentConfig.componentPercent / 100) : 0;
                        } else if(dependentFixedValue) {
                            amount = dependentFixedValue ? (dependentFixedValue.amount * component.componentConfig.componentPercent / 100) : 0;
                        } else {
                            amount = 0;
                        }
                        
                    }
                    break;
                case 'amountPerDay':
                    const workingDaysInMonth = getWorkingDaysInMonth(workWeek);
                    amount = workingDaysInMonth * component.componentConfig.amountPerDay;
                    break;
                case 'percentageOfCTC':
                    amount = monthlyCompensation * component.componentConfig.componentPercent / 100;
                    break;
            }
        }

        return typeof amount === "number" ? amount.toFixed(TenantService.get(TENANT.DECIMAL_FORMAT)) : amount;
    }

    export function getTenantDeciamlFormattedAmount(value) {
        let amount = value ? value : 0;
        if(typeof amount === "string") {
           amount = parseFloat(amount);
           amount = amount.toFixed(TenantService.get(TENANT.DECIMAL_FORMAT)) || amount
        } else {
            amount = amount.toFixed(TenantService.get(TENANT.DECIMAL_FORMAT)) || amount;
        }
        return parseFloat(amount);
    
      }
    
    export function getVariableAmountByAmount(component, compensationPeriod, compensation, workWeek, allComponentData, defaultValue, employeeDetails) {
        let amount = 0;
        const monthlyCompensation:any = getCompensationInPerMonth(compensationPeriod, compensation, workWeek, employeeDetails);
        if (component.isVariable && component.componentConfig.configureAmountBasis) {
            switch (component.componentConfig.configureAmountBasis) {
                case 'percentageOfBasicSalary':
                    amount = monthlyCompensation * component.componentConfig.componentPercent / 100;
                    if(isInCompliance(COUNTRY_CODE.INDIA)) {
                       let index = allComponentData.findIndex(component => (component.name == CONSTANTS.BASIC && component.defaultComponent));
                       if(index != -1) {
                            amount = defaultValue * component.componentConfig.componentPercent/ 100;
                       }
                    }
                    break;
                case 'percentageOfSpecificComponent':
                    const dependentComponent = getDependentComponent(component.componentConfig.basisComponentId, allComponentData);
                    if (dependentComponent) {
                        amount = defaultValue * component.componentConfig.componentPercent / 100;
                    }
                    break;
                case 'amountPerDay':
                    const workingDaysInMonth = getWorkingDaysInMonth(workWeek);
                    amount = workingDaysInMonth * component.componentConfig.amountPerDay;
                    break;
                case 'percentageOfCTC':
                    amount = monthlyCompensation * component.componentConfig.componentPercent / 100;
                    break;
            }
        }

        return amount;
    }

    export function getCompensationInPerMonth(compensationPeriod, compensation, workWeek, employeeDetails) {
        let monthlyCompensation = 0;
        if (compensation) {
            switch (compensationPeriod) {
                case '365':
                    monthlyCompensation = compensation / 12;
                    break;
                case '30':
                    monthlyCompensation = compensation;
                    break;
                case 'weekly':
                    monthlyCompensation = 52 * compensation / 12;
                    break;
                case 'hourly':
                    const totalWorkHours = getTotalWorkHoursInMonth(workWeek, employeeDetails);
                    monthlyCompensation = totalWorkHours * compensation;
                    break;
                default:
                    break;
            }
        }

        return getFormattedAmount(monthlyCompensation);
    }

    export function getDependentComponent(dependentComponentId, allComponentData) {
        let dependentComponent;
        if (allComponentData && allComponentData.length > 0) {
            dependentComponent = allComponentData.find(c => c.id === dependentComponentId);
        }

        return dependentComponent;
    }

    export function getWorkingDaysInMonth(workWeek) {
        let totalWorkingDays = 0;
        const daysInMonth = moment().daysInMonth();
        for (var i = 1; i <= daysInMonth; i++) {
            const day = moment().date(i);
            workWeek.forEach((w) => {
                if (w.isWorkingDay && w.day === day.format('dddd').toLowerCase()) {
                    totalWorkingDays += 1;
                }
            });
        }

        return totalWorkingDays;
    }

    export function getFormattedAmount(value) {
    let amount = value ? value : 0;
    if(typeof amount === "string") {
       amount = parseFloat(amount);
       amount = amount.toFixed(2)
    } else {
      amount = amount.toFixed(2);
    }
    return amount;

  }
  export function isValidZipcode(value,countryCode){
    let isValid = false;
    switch(countryCode) {
        case COUNTRY_CODE.INDIA:
          const regexZIP = new RegExp(ZIPCODE_REGEX.IND);
          isValid = !regexZIP.test(value);
          return isValid;
        default:
            isValid = true;
    }
    return isValid;
  }

  export function getSelectedIdFromDropDown (value, options, key) {
      let selectedId = "";
      if (value && Array.isArray(value)) {
        value.forEach((element) => {
          let dropdownValues = options[element];
          if (dropdownValues && dropdownValues[key]) {
            selectedId = dropdownValues[key];
          }
        });
      }
      return selectedId;
    };

    export function getSelectedIdFromObject (value, key) {
    let selectedId = "";
    if (!Utility.isEmpty(value) && typeof value === "object") {
      selectedId = value[key];
    }
    return selectedId;
  }

    export function removeFirstDecimalFromInput(value) {
        let formattedValue = value;
        if(!Utility.isEmpty(value)) {
            if(typeof value === "string" && value.length > 1) {
                formattedValue = value.replace(/^0+/, '');
                // formattedValue = numberValue.toString();
            } else if(typeof value === "number") {
                let stringValue = value.toString();
                if(stringValue.length > 1) {
                    let newValue = stringValue.replace(/^0+/, '');
                    formattedValue = parseFloat(newValue);
                }
            }
        }
        return formattedValue;
    }

    export function isUSCompliance() {
        const { tenant } = TenantManager.getPeopleTenantData();
        const countryCode = tenant && tenant.countryCode ? tenant.countryCode : "";
        return countryCode === COUNTRY_CODE.US
    }

    export function isIndiaCompliance() {
        const { tenant } = TenantManager.getPeopleTenantData();
        const countryCode = tenant && tenant.countryCode ? tenant.countryCode : "";
        return countryCode === COUNTRY_CODE.INDIA
    }

    export function isMYCompliance() {
        const { tenant } = TenantManager.getPeopleTenantData();
        const countryCode = tenant && tenant.countryCode ? tenant.countryCode : "";
        return countryCode === COUNTRY_CODE.MY
    }
    export function isSGCompliance() {
        const { tenant } = TenantManager.getPeopleTenantData();
        const countryCode = tenant && tenant.countryCode ? tenant.countryCode : "";
        return countryCode === COUNTRY_CODE.SG
    }
    

    export function isBenefitEnabled() {
        const { tenant } = TenantManager.getPeopleTenantData();
        const countryCode = tenant && tenant.countryCode ? tenant.countryCode : "";
        return countryCode === COUNTRY_CODE.US
    }

    export function isEffectiveSalaryApplied (isEffectiveSalary, visibleCompensation) {
        if (visibleCompensation === undefined || visibleCompensation === null){
            return false
        }
        let effectiveDate = visibleCompensation.effectiveDate;
        if(effectiveDate != '' && isEffectiveSalary) {
            if(moment().isSameOrAfter(effectiveDate)) {
              return true;
            } else {
              return false;
            }
        } else {
          return false;
        }
    }
    export function getCPFYears() {
        let cpfYears = [];
        if (TenantService.get(TENANT.DATE_OF_CREATION)) {
            let tenantCreationYear = new Date(TenantService.get(TENANT.DATE_OF_CREATION)).getFullYear();
            while (tenantCreationYear <= new Date().getFullYear()) {
                cpfYears.push(tenantCreationYear.toString());
                tenantCreationYear++;
            }
        }

        return cpfYears;
    }
export function getMaskedValue(value, field) {
    switch (field) {
        case 'socialSecurityNumber':
            //eg: '212-23-2333'
            if (value && value.length === 9) {
                let sociNo = `${value.substring(0,3)}-${value.substring(3,5)}-${value.substring(5,9)}`
                return sociNo;
            } else {
                return value;
            }
        default:
            return value;
    }

}

export function getTotalWorkHoursInMonth(workWeek, employeeDetails) {
        let totalWorkHours = 0;
        const daysInMonth = moment().daysInMonth();
        for (var i = 1; i <= daysInMonth; i++) {
            const day = moment().date(i);
            workWeek?.forEach((w) => {
                if (w.isWorkingDay && w.day === day.format('dddd').toLowerCase()) {
                    if (isIndiaCompliance()) {
                        totalWorkHours += parseFloat(employeeDetails.hourlyWageDefaultHrs)
                    } else {
                        totalWorkHours += w.duration;
                    }
                }
            });
        }

        return totalWorkHours;
    }

export function getTotalWorkingDaysBetweenDays(from, to, workWeek) {
    let totalWorkingDays = 0;
    var now = moment(from).clone(), dates = [];

    while (now.isSameOrBefore(moment(to))) {
        dates.push(now.format('YYYY/MM/DD'));
        now.add(1, 'days');
    }
    dates.forEach(d => {
        workWeek.forEach((w) => {
            if (w.isWorkingDay && w.day === moment(d, "YYYY/MM/DD").format('dddd').toLowerCase()) {
                totalWorkingDays += 1;
            }
        });
    })

    return totalWorkingDays;
}
export function downloadAsZip(blobDataArray,zipFileName){
    var zip = new JSZip();
    blobDataArray.forEach((file)=>{
        zip.file(file.name, file);
    })

    //may use in future FOR IMAGE FILE

    // zip.file("Hello1.pdf", blobData);
    // var img = zip.folder("images");
    // img.file("smile.gif", imgData, {base64: true});

    zip.generateAsync({type:"blob"}).then(function(content) {
        saveAs(content, zipFileName);
    })
}

export const decodeBase64Uri: (decodedData: string) => string = (encodedData: string) => {
    return decodeURIComponent(Buffer.from(encodedData, 'base64').toString('ascii'));
};

export const encodeBase64Uri: (encodedData: string) => string = (decodedData: string) => {
    return Buffer.from(encodeURIComponent(decodedData), 'ascii').toString('base64');
};

export function getFileNameFromContentDisposition(contentDisposition: string) {
    let filename = '';
    try {
        filename = contentDisposition.split(';')[1].split('filename')[1].split('=')[1].replace('"', '').replace('"', '').trim();
    } catch (error) { }

    return filename;
}
export function getStateListFromCountry() {
    let state = [];
    let address = TenantService.get(TENANT.ADDRESS);
    if(address && address.country) {
        switch(address.country){
            case COUNTRY.US:
                state = US_STATES;
                break;
            case COUNTRY.IN:
                state = IN_STATES;
                break;
            default:
                state = [];
        }
    }
    return state;
}

export function getTenantCountryCode() {
    const { tenant } = TenantManager.getPeopleTenantData();
    const countryCode = tenant && tenant.countryCode ? tenant.countryCode : "";
    return countryCode;
}
export function getCountryPhoneCode() {
    
    let countryPhoneCode = Countries.find(c=>c.value == TenantService.get(TENANT.COUNTRY_CODE));
    if(countryPhoneCode && countryPhoneCode['dial_code']) {
        return countryPhoneCode['dial_code']
    }
    return ''
}

/**
  * Function to find the id of first error field
  */
 export function scrollToError(fieldName) {
    try{
        const firstElementWithError = document.querySelector(`.${fieldName}`);
        if(firstElementWithError) {
            scrollTo(firstElementWithError);
        }
    } catch(e) {
        console.log(e)
    }
}

export function scrollToErrorNew(fieldIds: string[]) {
    try{
        if (Array.isArray(fieldIds)) {
            for (let fieldId of fieldIds) {
                const el = document.querySelector(`.${fieldId}`);
                if(el) {
                    scrollTo(el);
                    break;
                }
            }
        }
    } catch(e) {
        console.log(e)
    }
}
/**
* Function to scroll to error field
*/
export function scrollTo(el: Element): void {
    if(el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
}
export function getYearsFrom2020ToTillPreviousYear() {
    let years = [];
    if ( TenantService.get(TENANT.DATE_OF_CREATION)) {
        let tenantCreationYear = new Date( TenantService.get(TENANT.DATE_OF_CREATION)).getFullYear();
        if (tenantCreationYear >= 2020) {
            for (let i = new Date().getFullYear() - 1; i >= 2020; i--) {
                    years.push({ id: i, name: i.toString() });
            }
        }
    }
    return years;
}

export function getIRASReportYears() {
    let cpfYears = [];
    let tenantCreationYear = new Date().getFullYear();
    tenantCreationYear -= 2;
    while (tenantCreationYear <= new Date().getFullYear()) {
        cpfYears.push({ id: tenantCreationYear, name: tenantCreationYear.toString() });
        tenantCreationYear++;
    }
    return cpfYears;
}
export function isComponentFormulaConfiguration() {
    return (isIndiaCompliance());
}
export function getNextChar(char) {
    return String.fromCharCode(char.charCodeAt(0) + 1);
  }
  export function isOperator(inputStr) {
      let op = ['+', '-', '*', '/', '==', '===','%','^'];
      return ( op.some(o=>o==inputStr))
         
}
export function isWeekFilterEnable() {
    return false
}
export function isRehireEnable() {
    return isMYCompliance() || isSGCompliance() || isIndiaCompliance() || TenantService.get(TENANT.CUSTOM_FIELD_SECTION_ENABLED);
}

export function getLocationColumnName(tenantDetails) {
    let isLocationActive = false;
        const { additionalSettings } = tenantDetails || "";
        const locationSettings = additionalSettings
            ? additionalSettings?.["LOCATION"]
            : {};
        isLocationActive = locationSettings?.trackLocation || false;
        const locationColumnName = isLocationActive ? locationSettings?.locationLabel : "";

        return {isLocationActive, locationColumnName};
}
export function isProfessionalPlan() {
    return isShiftOvertimePlanApplicable(TenantService.get(TENANT.PLAN_NAME));
}
export function showUpgradePlanAlert(feature) {
    return showAlert(
        `<div class="fs-l pb-s">Want to enable ${feature} today?</div>`,
        `<div class="fw-m mb-m">We love that you are so active on Deskera. To add this you’ll need to upgrade your plan.</div>
        <div>Please chat with us or contact <a href='mailto:care@deskera.com'>care@deskera.com</a></div>`
    );
}
export function convertCamelCaseToWord(text) {
    if(!Utility.isEmpty(text)) {
        const result = text.replace(/([A-Z])/g, " $1");
        return result.charAt(0).toUpperCase() + result.slice(1);
    } else {
        return text
    }  
}
export function isCompanyDetailsSectionWiseSave() {
    return ApiConstants.CURRENT_ENVIRONMENT === 'DEV'
}

export function getDefaultPayslipUUID() {
    if(!Utility.isEmpty(TenantService.get(TENANT.DEFAULT_PAYSLIP))) {
        const filterObj = TenantService.get(TENANT.DEFAULT_PAYSLIP)?.find(p=>p.countryCode === TenantService.get(TENANT.COUNTRY_CODE));
        return (filterObj && filterObj.uuid) ? filterObj.uuid : '?type=PAYSLIP'
    } else {
        return '?type=PAYSLIP'
    }
}
export function getlocalizationText(text) {
    return (LOCALISATION_TEXT[TenantService.get(TENANT.COUNTRY_CODE)] && LOCALISATION_TEXT[TenantService.get(TENANT.COUNTRY_CODE)][text]) ? LOCALISATION_TEXT[TenantService.get(TENANT.COUNTRY_CODE)][text]: "";
}

export function showAccessDeniedAlert() {
    return showAlert(
        `<div class="fs-l pb-s">Access Denied</div>`,
        `<div class="mb-m">You do not have access to this feature as your access to salary information is restricted.</div>
        <div>Please contact your organisation Admin.</div>`
    );
}

export function showBooksAccessAlert(feature) {
    return showAlert(
        `<div class="fs-l pb-s">Access Denied</div>`,
        `<div class="mb-m">You don't have access to ${feature} feature.</div>
        ${TenantService.get(TENANT.IS_ADMIN) ? "<div>Permission <a href='"+ ApiConstants.PRODUCT_URL_GO + "users"+"' target='_blank' rel='noopener noreferrer'>View</a>.</div>":"<div>Please contact your organisation Admin.</div>"}`
    );
}
export const showUserLimitExceedsAlert = () => {
    showAlert(
        `<div class="fs-l">User Limit Exceeds</div>`,
        `<div class="fw-m fs-m mb-r">Want to add more users today?</div>
         <div class="mb-l">We love that you are so active on Deskera. To add more employees, you’ll need to upgrade your plan.</div>`,
        [
            {
                title: "Upgrade Plan",
                className: "bg-app text-white",
                onClick: () => {
                    window.open(ApiConstants.PRODUCT_URL_GO + "billing", "_blank");
                }
            },
            {
                title: "Close",
                className: "ml-m",
                onClick: () => {}
            }
        ]
    );
}

export function delay (delayInms) {
    return new Promise(resolve => setTimeout(resolve, delayInms));
}

export function getInfoIconWithTooltip(tooltip) {
    return `<span class="info_error_icon cursor-hand" style="margin-top: 1px;" data-tip="${tooltip}"><img class="ic-s" src= ${ic_info_warning} /></span>`
}

export function saveUserPreferences(key, value) {
    localStorage.setItem(key, value);
}
export function pageScroll (isScroll) {
    let container = document.getElementById('containerDiv');
    if(container) {
        container.style.overflowY = isScroll ? 'auto': 'inherit';
    }
}

const HTML_REGEX = new RegExp("<(br|basefont|hr|input|source|frame|param|area|meta|!--|col|link|option|base|img|wbr|!DOCTYPE).*?>|<(a|abbr|acronym|address|applet|article|aside|audio|b|bdi|bdo|big|blockquote|body|button|canvas|caption|center|cite|code|colgroup|command|datalist|dd|del|details|dfn|dialog|dir|div|dl|dt|em|embed|fieldset|figcaption|figure|font|footer|form|frameset|head|header|hgroup|h1|h2|h3|h4|h5|h6|html|i|iframe|ins|kbd|keygen|label|legend|li|map|mark|menu|meter|nav|noframes|noscript|object|ol|optgroup|output|p|pre|progress|q|rp|rt|ruby|s|samp|script|section|select|small|span|strike|strong|style|sub|summary|sup|table|tbody|td|textarea|tfoot|th|thead|time|title|tr|track|tt|u|ul|var|video).*?<\/\\2>", "gim");

export function stringSanitizer(value) {
    if (typeof value === "string" && HTML_REGEX.test(value)) {
        return dompurify.sanitize(value, { FORCE_BODY: true });
    }

    return value;
}
export function extractTextFromHTML(htmlString) {
    // Create a temporary div element
    const tempDiv = document.createElement('div');
    // Set the innerHTML of the div to the HTML string
    tempDiv.innerHTML = htmlString;
    // Return the text content of the div
    return tempDiv.textContent || tempDiv.innerText || '';
}

export function deepHtmlExtractFromObject(content) {
    return JSON.parse(extractTextFromHTML(JSON.stringify(content)))
}

export const showAlertEmployeeExpense = (action) => {
    showAlert(
        `Trying to ${action}!`,
        `The selected user is already used in Expense automation as an approver. If you still want to ${action} this employee, Please remove it as an approver from automation.`,
        [
            {
                title: "Go to automation",
                className: "bg-app text-white",
                onClick: () => {
                    RouteManager.navigateToPage(PAGE_ROUTES.AUTOMATION);
                }
            },
            {
                title: "Close",
                className: "ml-m border-m",
                onClick: () => {}
            }
        ]
    );
}

export const renderFileHtml = (file,index,rowIndex?) => {
    let fileType = file.title?.split(".").pop();
    if (fileType === FILE_TYPE.TXT || fileType === FILE_TYPE.PDF) {
      return (
        `<div style=" width: 180px " onclick="event.stopPropagation();">
        ${getAttachmentTitleWithIconHtml(file, false, index, rowIndex)}
        <iframe width="180" src=${file.path} title=${file.title} ></iframe>
        </div>`
      );
    } else if (
      fileType === FILE_TYPE.JPG ||
      fileType === FILE_TYPE.JPEG ||
      fileType === FILE_TYPE.PNG ||
      fileType === FILE_TYPE.SVG
    ) {
      return (
        `<div style=" width: 180px " onclick="event.stopPropagation();">
          ${getAttachmentTitleWithIconHtml(file, false, index,rowIndex)}
          <img width="180" src=${file.path} alt=${file.title} />
        </div>`
      );
    } else {
      return (`<div style=" width: 180px " onclick="event.stopPropagation();">
      ${getAttachmentTitleWithIconHtml(file, false, index,rowIndex)}
      <div>${i18next.t("NO_PREVIEW")}</div>
    </div>`)
    }
  }; 

  export const getAttachmentTitleWithIconHtml = (attachment, isDarkTheme, index,rowIndex) => {
    let icon;
    if (FILE_EXTENSION_GROUP.PDF.includes(attachment.type)) {
      icon = DKIcons.doc_type.ic_pdf;
    } else if (FILE_EXTENSION_GROUP.DOC.includes(attachment.type)) {
      icon = DKIcons.doc_type.ic_doc;
    } else if (FILE_EXTENSION_GROUP.PPT.includes(attachment.type)) {
      icon = DKIcons.doc_type.ic_ppt;
    } else if (FILE_EXTENSION_GROUP.XLS.includes(attachment.type)) {
      icon = DKIcons.doc_type.ic_xls;
    } else {
      icon = DKIcons.doc_type.ic_jpg;
    }
    attachment['index'] = index;
    attachment['rowIndex'] = rowIndex;
  
    return (
      `<div
        class="row align-items-center mt-auto mb-xs"
        onclick="event.stopPropagation();"
        style="
          height: 24px;
          max-Width: '100%'"
      >
        <img src="${icon}" class="ic-xs-2" onclick="event.stopPropagation();" />
        <div class="ml-r  pr-s"
          style=" text-overflow: ellipsis;  white-space: nowrap; overflow: hidden;"
          onclick="event.stopPropagation();"
        >${attachment.title}
        </div>
        <img 
          src="${DKIcons.ic_delete}"
          class="ic-xs-2 ml-auto cursor-hand attach-del-btn ${PermissionUtils.hasAccess(MODULE.CANDIDATE,[ACTION.EDIT,ACTION.DELETE]) ? "":"d-none"}" 
          onclick="event.stopPropagation(); window.onDeleteAttachment(' ${Utility.encodeJSON(attachment)} ')"
        />
      </div>`
    );
  };

  export const showAlertEmployeeLeave = (action) => {
    showAlert(
        `Trying to ${action}!`,
        `The selected user is already used in eLeave automation as an approver. If you still want to ${action} this employee, Please remove it as an approver from automation.`,
        [
            {
                title: "Go to automation",
                className: "bg-app text-white",
                onClick: () => {
                    RouteManager.navigateToPage(PAGE_ROUTES.AUTOMATION);
                }
            },
            {
                title: "Close",
                className: "ml-m border-m",
                onClick: () => {}
            }
        ]
    );
}